import React from 'react';
import {Col, Container, Row, Card, CardBody, Button} from 'reactstrap';
import {connect} from 'react-redux';
import LoadingProgress from '../../components/LoadingProgress'
import ReactQueryParams from 'react-query-params';
import {ButtonToolbar} from 'reactstrap';
import {fetchCustomeraDataIfNeeded} from '../../redux/actions/CustomersActions';
import {fetchUtilsDataIfNeeded} from '../../redux/actions/UtilsActions'
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
import FilterSelector from './components/FilterSelector';
import MultiSelectionFilter from './components/MultiSelectionFilter';
import CustomersTable from './components/CustomersTable'
import * as TextManager from "../../modules/languages/TextManager";
import StatusSelector from './components/StatusSelector'
import DateSelector from '../../components/DateSelector'
import SecondStatusSelector from './components/SecondStatusSelector'
import ModalComponent from '../../components/ModalPaymentDocs'
import ModalTasks from '../../components/ModalTasks'
import ModalClickOne from '../../components/ModalClickOne'
import * as http from "../../modules/http";
import ThreeQuesWarning from '../../components/ThreeQuesWarning'
import axios from 'axios';
import * as environment from '../../../src/modules/environment.js';
import PieNewDeals from "../../components/PieNewDeals";


export class Customers extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
            timerLoaded: false
        };

        this.fileUploadExcl = React.createRef();
    }

    componentDidMount() {

        //console.log("MOUNT CUSTOMEr")

        if (this.props.userData && this.props.userData.data && this.props.userData.data.userType === 5) { // ManagerCellular012
            let queryParam = {};
            queryParam['provider'] = [3];
            this.setQueryParams(queryParam);

            this.props.dispatch(fetchCustomeraDataIfNeeded(this.queryParams));
        }
        else if(this.props.userData && this.props.userData.data && this.props.userData.data.userType === 6) { // ManagerInternet018
            let queryParam = {};
            queryParam['provider'] = [24];
            this.setQueryParams(queryParam);

            this.props.dispatch(fetchCustomeraDataIfNeeded(this.queryParams));

        }
        else {
            this.props.dispatch(fetchCustomeraDataIfNeeded(this.queryParams));
        }

        this.props.dispatch(fetchUtilsDataIfNeeded());
    }

    changeSearch = (e) => {
        this.setState({searchValue: e.target.value});
    };

    filterDataBySearch = record => {
        //console.log(record);
        if (this.state.searchValue === undefined || this.state.searchValue === null || this.state.searchValue === "") {
            return true;
        } else {
            let matchingRecords = Object.values(record ? record : {});

            let retVal = false;
            matchingRecords.forEach(mr => {
                // debugger;
                if (typeof mr === 'string') {
                    if (mr.toLowerCase().includes(this.state.searchValue.toLowerCase())) {
                        retVal = retVal || true;
                    }
                } else if(typeof mr === 'number' ) {
                    if(mr.toString(16).toLowerCase().includes(this.state.searchValue.toLowerCase())) {
                        retVal = retVal || true;
                    }
                } else if (typeof mr === 'object') {
                    retVal = retVal || this.filterDataBySearch(mr);
                }
            });
            return retVal;
        }
    };

    /*clearWarning = () => {
        http.postToServer(
            'clear/warning',
            {},
            (response) => {
                this.props.dispatch(fetchUtilsDataIfNeeded(true));

            },
            (response) => {
                console.log('clearWarning');
            }
        );

    };*/

    showFileUploadExcl = (e) => {
        e.preventDefault();
        this.fileUploadExcl.current.click();
    };

    handleUploadFileExcl = (e) => {

        let file = e.target.files[0];
        let formData = new FormData();
        formData.append('file', file);

        e.target.value = null;

        axios.defaults.withCredentials = true;

        axios.post(environment.getServerBasePath() + '/excel/upload', formData,
            {
                headers: {'X-Custom-Referer': window.location.host,
                    'X-Custom-Is-Impersion': localStorage.getItem('isImpersonate'),
                    'X-Custom-Impersonated-Affiliate': localStorage.getItem('impersonatedAffiliate')},
                withCredentials:true,
                responseType: 'arraybuffer'
            }
        ).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'download.xlsx');
            document.body.appendChild(link);
            link.click();
        })
            .catch(({ response }) => {
                let ab2str = require('arraybuffer-to-string');
                let arr = new Uint8Array(response.data);

                let message = JSON.parse(ab2str(arr))['message'];

                alert(message);
            });

        /*http.postToServer(
            'excel/upload',
            formData,
            (response) => {

                //const outputFilename = `${Date.now()}.xlsx`;

                const url = URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'download.xlsx');
                document.body.appendChild(link);
                link.click();
            },
            (response) => {
                console.log('error Exsl ' + response.data.message);
                //this.setState({errorInUploadFile: true, errorText: response.data.message})
            }
        );*/
    };

    render() {

        let dealTypes = [/*{value: 0, label: 'All'}, */{value: 1, label: 'סלולר'},
            {value: 2,label: 'טלוויזיה'},
            {value: 3, label: 'אינטרנט'}];
        let providers = [];
        let stores = [];
        let status = [
            {value: 1, label: TextManager.getCurrentTextResource().Customers.newCustomers},
            {value: 2, label: TextManager.getCurrentTextResource().Customers.activeCustomers},
            {value: 3, label: TextManager.getCurrentTextResource().Customers.inactiveCustomers},
            {value: 4, label: TextManager.getCurrentTextResource().Customers.inMaintenance},
            {value: 5, label: TextManager.getCurrentTextResource().Customers.halfDone},
            {value: 6, label: 'לקוחות מעטפה'}];

        let statusLong = [
            {value: 1, label: TextManager.getCurrentTextResource().Customers.newCustomers},
            {value: 2, label: TextManager.getCurrentTextResource().Customers.activeCustomers},
            {value: 3, label: TextManager.getCurrentTextResource().Customers.inactiveCustomers},
            {value: 4, label: TextManager.getCurrentTextResource().Customers.inMaintenance},
            {value: 5, label: TextManager.getCurrentTextResource().Customers.halfDone},
            {value: 6, label: 'לקוחות מעטפה'},
            {value: 7, label: 'לקוחות עם תזכורת'},
            {value: 8, label: 'לקוחות עם תמונה'},
            {value: 9, label: 'לקוחות בטיפול'},
            {value: 10, label: 'פעיל אוטו'},
            {value: 11, label: 'חדש מברג'},
            {value: 12, label: 'הזמנה עלתה אוטומציה'},
            {value: 13, label: 'בוצע חלקית אוטומציה'}
            ];

        let secondStatus = [
            {value: 0, label: TextManager.getCurrentTextResource().Customers.secondStatusNo},
            {value: 1, label: TextManager.getCurrentTextResource().Customers.secondStatusYes}];

        let isNewInLine = [
            {value: 1, label: 'קו חדש'},
            {value: 2, label: 'קו מנוייד'}];

        let duplicateTypes = [ {value: 1, label: 'המקור'}, {value: 2,label: 'השכפול'} ];

        if (this.props.utilsData && this.props.utilsData.data) {
            for (let indx in this.props.utilsData.data.providers) {
                providers.push(this.props.utilsData.data.providers[indx]);
            }

            for (let indx in this.props.utilsData.data.stores) {
                stores.push(this.props.utilsData.data.stores[indx]);
            }
        }

        let userType = undefined;
        let isManager = false;
        let isAdmin = false;
        if (this.props.userData && this.props.userData.data && this.props.userData.data.userType) {

            userType = this.props.userData.data.userType;
            isManager = this.props.userData.data.isManager;
            isAdmin = this.props.userData.data.isAdmin;
        }

        let data = this.props.data;

        if (this.state.searchValue !== '') {
            data = this.props.data.filter(this.filterDataBySearch)
        }

        //const biggerThan1025 = window.matchMedia("(min-width: 1025px)").matches;
        let isWarning = false;
        if (this.props.userData && this.props.userData.data && this.props.userData.data.id &&
            this.props.utilsData && this.props.utilsData.data && this.props.utilsData.data.isWarning) {
            if( environment.ListManagersFeatures.includes(this.props.userData.data.id) || isAdmin) {
                //isWarning = this.props.utilsData.data.isWarning < 3;
                isWarning = !(this.props.utilsData.data.isWarning.war1 === true && this.props.utilsData.data.isWarning.war2 === true &&
                             this.props.utilsData.data.isWarning.war3 === true)
            }
        }

        let finalStatus = status;
        let showImageDeal = true;
        if (this.props.userData && this.props.userData.data && this.props.userData.data.id) {
            if( environment.ListManagersFeatures.includes(this.props.userData.data.id) || isAdmin) {
                finalStatus = statusLong;
            }
        }

        /*if(!showImageDeal && this.props.data !== undefined) {
            data = this.props.data.filter(e => e.deal_image === 0)
        }*/
        if(!showImageDeal && data !== undefined) {
            data = data.filter(e => e.deal_image === 0)
        }


        let tmpNewDealsCnt = 0;
        if(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].status === 1 || data[i].status === 11) {
                    tmpNewDealsCnt += data[i].numOfLines;
                }
            }
        }
        let dataNewDeals = [{value: tmpNewDealsCnt, fill: '#f6da6e'}];

        let tmpLetterCnt = 0;
        if(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].lu_by_user_type === environment.ListUserTypesEnum.Store) {
                    tmpLetterCnt += data[i].numOfLines;
                }
            }
        }
        let dataLetterDeals = [{value: tmpLetterCnt, fill: '#70bbfd'}];

        let tmpMaintDealsCnt = 0;
        if(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].status === 6) {
                    tmpMaintDealsCnt += data[i].numOfLines;
                }
            }
        }
        let dataMaintDeals = [{value: tmpMaintDealsCnt, fill: '#c88ffa'}];

        let tmpReminderDealsCnt = 0;
        if(data) {
            for (let i = 0; i < data.length; i++) {
                if (data[i].deal_reminder === 1) {
                    tmpReminderDealsCnt += data[i].numOfLines;
                }
            }
        }
        let dataReminderDeals = [{value: tmpReminderDealsCnt, fill: '#4ce1b6'}];

        let titleIvr = 'IVR' + '  שליחת שיחת ';

        return (
            <Container className='dashboard'>

                {this.props.status === 'request' &&
                <Row>
                    <LoadingProgress/>
                </Row>
                }

                {this.props.status === 'error' &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>
                }

                {this.props.status === 'success' &&
                <span>
                    <Row>
                      <Col md={3} md={12}>
                        <Card>
                            <CardBody style={{padding: "1.25rem"}}>
                                <h3 style={{textAlign: 'right'}}>{TextManager.getCurrentTextResource().Customers.customers}{/*userType !== 5 && <span style={{marginRight: '15px', color: 'green'}}>מוקד התפעול לשירותך 0733998090</span>*/}</h3>
                                <div style={{display: 'flex', height: '100%', width: '85%'}}>
                                  <ButtonToolbar className='custom_dashboard_header_panel'>

                                      <MultiSelectionFilter items={isNewInLine} name="סוג קו"
                                                            queryParam="isNew" endpoint='customers'/>
                                      <MultiSelectionFilter items={secondStatus} name="זמניים פתוחים"
                                                            queryParam="secondStatus" endpoint='customers'/>
                                      <MultiSelectionFilter items={finalStatus} name="סטטוס" queryParam="status" endpoint='customers'/>
                                      {(userType !== 5 && userType !== 6) && <MultiSelectionFilter items={providers}
                                                                               name={TextManager.getCurrentTextResource().Customers.provider}
                                                                               queryParam="provider" endpoint='customers'/>}
                                      {(isAdmin || isManager) && <MultiSelectionFilter items={stores}
                                                                                       name={TextManager.getCurrentTextResource().Settings.store}
                                                                                       search storeGroup
                                                                                       queryParam="store" endpoint='customers'/>}
                                      {(userType !== 5 && userType !== 6) &&
                                      <MultiSelectionFilter items={dealTypes} name='סוג עסקה' queryParam="dealtype" endpoint='customers'/>}
                                      <MultiSelectionFilter items={duplicateTypes} name='שכפולים' queryParam="duplicate" endpoint='customers'/>
                                      <DateSelector endpoint='customers'/>
                                      {isAdmin && <ModalComponent color='primary'
                                                                  title='Upload documents'
                                                                  header
                                                                  queryParam={this.queryParams}>
                                          <Button outline color='primary' size='sm'>Upload</Button>
                                      </ModalComponent>}

                                      {isAdmin && <div>
                                          <input type="file" id="exampleFile"
                                                 style={{display: 'none', marginLeft: '5px'}}
                                                 ref={this.fileUploadExcl}
                                                 accept='.xlsx'
                                                 onChange={e => this.handleUploadFileExcl(e)}/>
                                          <Button outline color='primary' size='sm'
                                              onClick={(e) => this.showFileUploadExcl(e)}>Upload Excl</Button>
                                      </div>}

                                  </ButtonToolbar>
                                </div>
                            </CardBody>

                            <CardBody style={{padding: "1.25rem"}}>
                                <div style={{display: 'flex', height: '100%', justifyContent: 'flex-end'}}>
                                  <ButtonToolbar className='custom_dashboard_header_panel'>
                                      <form className='topbar__search material-form'>
                                        <div
                                            className='search_field_form_control material-form__field topbar__search-field'>
                                            <div className='search_field_root search_field_custom-underline'
                                                 style={{border: 'groove'}}>
                                                <input className='search_field_custom-input' dir="rtl"
                                                       placeholder={TextManager.getCurrentTextResource().Text.searchByNameOrID}
                                                       value={this.state.searchValue}
                                                       onChange={(e) => this.changeSearch(e)}/>
                                            </div>
                                        </div>
                                      </form>
                                  </ButtonToolbar>
                                </div>
                            </CardBody>

                            {/*<CardBody style={{padding: "1.25rem"}}>
                                <div style={{direction: "rtl"}}>
                                <Row>
                                    <Col md={4}>
                                        <ModalTasks color='primary'
                                                    title='משימות'
                                                    header>
                                                <Button outline color={'primary'}
                                                        size='sm'
                                                        style={{width: '100%'}}
                                                    >{'משימות ' + '(' + this.props.tasksCnt + ')'}</Button>
                                            </ModalTasks>
                                    </Col>
                                </Row>
                                </div>
                            </CardBody>*/}

                            <CardBody style={{padding: "1.25rem"}}>
                                <Row>
                                    <Col md={2}>
                                        {(isAdmin || isManager || isWarning) && <PieNewDeals text='לקוחות מעטפה' data={dataLetterDeals} type='envelope'/>}
                                    </Col>
                                    <Col md={2}>
                                        {(isAdmin || isManager || isWarning) && <PieNewDeals text='לקוחות חדשים' data={dataNewDeals} type='new'/>}
                                    </Col>
                                    <Col md={2}>
                                        {(isAdmin || isManager || isWarning) && <PieNewDeals text='לקוחות תזכורת' data={dataReminderDeals} type='remind'/>}
                                    </Col>
                                    <Col md={2}>
                                        {(isAdmin || isManager || isWarning) && <PieNewDeals text='לקוחות בטיפול' data={dataMaintDeals} type='maint'/>}
                                    </Col>
                                    <Col md={2}>
                                        {(isAdmin || isManager) && <ModalTasks color='primary'
                                                    title='משימות'
                                                    header>
                                            <Button outline color={this.props.tasksCnt > 0 ? 'danger' : 'primary'}
                                                    size='sm'
                                                    style={{width: '100%'}}
                                                /*style={biggerThan1025 ? {width: '610%'} : {width: '150%'}}*/>{'משימות ' + '(' + this.props.tasksCnt + ')'}</Button>
                                        </ModalTasks>}
                                        {(isAdmin || isManager) && <ModalClickOne color='primary'
                                                                                  title={titleIvr}
                                                                                  header>
                                            <Button outline color={'primary'}
                                                    size='sm'
                                                    style={{width: '100%'}}
                                            >{titleIvr}</Button>
                                        </ModalClickOne>}
                                    </Col>
                                    <Col md={2}>
                                        {/*isWarning && <ThreeQuesWarning color='secondary' className='alert--bordered'/>*/}
                                    </Col>
                                    {/*<Col md={2}>
                                        {(isAdmin || isManager) && <ModalClickOne color='primary'
                                                    title={titleIvr}
                                                    header>
                                            <Button outline color={'primary'}
                                                    size='sm'
                                                    style={{width: '100%'}}
                                                >{titleIvr}</Button>
                                        </ModalClickOne>}
                                    </Col>*/}
                                </Row>
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>
                    <Row>
                        <CustomersTable  key={'table'} data={data} userData={this.props.userData} refreshData={() => {
                            this.props.dispatch(fetchCustomeraDataIfNeeded(this.queryParams));
                        }}/>
                    </Row>
                </span>
                }

            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.customers.status,
        data: state.customers.data,
        userData: state.userData,
        utilsData: state.utilsData,
        tasksCnt: state.tasks.count,
        storeGroup: state.admin.storeGroup
    };
};

export default withRouter(connect(mapStateToProps)(Customers))